import React from 'react';
import Icon from './Icon';

const MenuIcon = ({ size, color = 'currentColor', className, ...props }) => {
  return (
    <Icon size={size} color={color} className={className} {...props}>
      <line
        x1="3" y1="6" x2="21" y2="6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="3" y1="12" x2="21" y2="12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="3" y1="18" x2="21" y2="18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default MenuIcon;
